const educationalLevels = [
  { value: 'Elementary Education', text: 'Nível Básico' },
  { value: 'Some High School', text: 'Primeiro Grau Completo' },
  { value: 'High School Diploma', text: 'Segundo Grau Completo' },
  { value: 'College', text: 'Superior Completo' },
];
export default educationalLevels;
